import React, {
    createContext,
    useContext,
    useState,
    useCallback,
    useMemo,
} from "react";

const PiPContext = createContext(undefined);

export function PiPProvider({ children }) {
    const isSupported = "documentPictureInPicture" in window;

    const [pipWindow, setPipWindow] = useState(null);

    const closePipWindow = useCallback(() => {
        if (pipWindow != null) {
            pipWindow.close();
            setPipWindow(null);
        }
    }, [pipWindow]);

    const requestPipWindow = useCallback(
        async (width, height) => {
            if (pipWindow != null) {
                return;
            }

            const pip = await window.documentPictureInPicture.requestWindow({
                width,
                height,
            });

            pip.addEventListener("pagehide", () => {
                setPipWindow(null);
            });

            [...document.styleSheets].forEach((styleSheet) => {
                try {
                    const cssRules = [...styleSheet.cssRules]
                        .map((rule) => rule.cssText)
                        .join("");
                    const style = document.createElement("style");
                    style.textContent = cssRules;
                    pip.document.head.appendChild(style);
                } catch (e) {
                    if (!styleSheet.href) return;

                    const link = document.createElement("link");
                    link.rel = "stylesheet";
                    link.type = styleSheet.type;
                    link.media = styleSheet.media.toString();
                    link.href = styleSheet.href;
                    pip.document.head.appendChild(link);
                }
            });

            setPipWindow(pip);
        },
        [pipWindow]
    );

    const value = useMemo(() => {
        return {
            isSupported,
            pipWindow,
            requestPipWindow,
            closePipWindow,
        };
    }, [isSupported, pipWindow, requestPipWindow, closePipWindow]);

    return <PiPContext.Provider value={value}>{children}</PiPContext.Provider>;
}

export default PiPContext;